import React from 'react';
import $ from 'jquery';
import Tippy from '@tippyjs/react';
import { PageContext } from '../../context/PageContext';
import {
    getPageUrlFromSlug,
    getUpgradePlanUrl,
} from '../../utilities/urlHelper';
import { addSuccessMessage } from '../../utilities/notificationUtilities';

class LinkMenu extends React.Component {
    static contextType = PageContext;

    constructor(props, context) {
        super(props);

        const { slug, authToken, authTokenId } = this.props;

        if (slug && authToken && authTokenId) {
            this.state = {
                authorizationId: authTokenId,
                authorizationLink: `${window.location.origin + getPageUrlFromSlug(slug)}?auth=${authToken}`,
                visibility: '',
            };
        } else {
            const { page } = context;
            this.state = {
                authorizationId: page.authorizationId,
                authorizationLink: page.authorizationLink,
                visibility: page.visibility,
            };
        }
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    generateShareLink = () => {
        const { page, setPage } = this.context;
        const url = `/api/teams/${window.teamId}/pages/${page.id}/link-shares`;
        const data = { _token: window.csrfToken };

        $.post({ url, data })
            .then(response => {
                if (response.success) {
                    page.authorizationId = response.id;
                    page.authorizationLink = response.url;
                    setPage(page);
                    this.setState({ authorizationId: response.id, authorizationLink: response.url });
                } else {
                    throw 'Error creating shared link';
                }
            })
            .catch(error => {
                console.error(error);
                const { setErrorMessage } = this.props;
                if (error.responseJSON && error.responseJSON.message) {
                    setErrorMessage(error.responseJSON.message);
                } else {
                    setErrorMessage('Error generating link');
                }
            });
    };

    onClickDestroy = () => {
        if (this.props.authTokenId) {
            this.destroyShareLinkFromId();
        } else {
            this.destroyShareLink();
        }
    };

    destroyShareLink = () => {
        const { page, setPage } = this.context;
        const URL = `/api/teams/${window.teamId}/pages/${page.id}/link-shares/${page.authorizationId}`;
        $.ajax({ url: URL, type: 'DELETE' })
            .then(response => {
                if (response.success) {
                    page.authorizationId = null;
                    page.authorizationLink = null;
                    setPage(page);
                    this.setState({ authorizationId: null, authorizationLink: null });
                } else {
                    throw 'Error disabling shared link';
                }
            })
            .catch(error => {
                console.error(error);
            });
    };

    destroyShareLinkFromId = () => {
        const { pageId, authTokenId } = this.props;
        const URL = `/api/teams/${window.teamId}/pages/${pageId}/link-shares/${authTokenId}`;

        $.ajax({ url: URL, type: 'DELETE' })
            .then(response => {
                this.close();

                if (response.success) {
                    if (this.props.onShareDisabled) {
                        this.props.onShareDisabled(authTokenId);
                    }

                    addSuccessMessage('Link sharing disabled for page');

                    this._isMounted && this.setState({ authorizationId: null, authorizationLink: null });
                } else {
                    throw 'Error disabling shared link';
                }
            })
            .catch(error => {
                console.error(error);
            });
    };

    close = () => {
        if (this.props.closeModal) {
            this.props.closeModal();
        }
    };

    render() {
        const { authorizationLink, visibility } = this.state;

        const existingText = (!window.publicSharingEnabled || !window.adminAllowsPageAuthorizations) && authorizationLink ? ' You can disable this link but will not be able to create another one.' : '';

        if (visibility === 'Publicly visible') {
            return (
                <div className="mt2">
                    <h4>Shareable public link</h4>
                    <p className="yellow italic">
                        This page is publicly visible, so you can send out the URL to share it.
                    </p>
                </div>
            );
        }

        return (
            <div className="mt2">
                <h4>Shareable public link</h4>
                <p className="yellow italic">
                    {window?.planName?.startsWith('basic-')
                        ? (<span>Only available on Scaling and Professional plans.</span>)
                        : (
                            !window.publicSharingEnabled && !window.teamOnTrial
                        && (
                            <span>

                                <a
                                    href="#"
                                    onClick={() => { this.props.closeModal(); loadAndBootIntercomIfUndefined(); Intercom('show'); }}
                                >
                    Contact us
                                </a>
                                {' '}
                to enable link sharing for your team.
                            </span>
                        )
                        )}

                    {existingText}
                </p>
                { (window.teamOnFreeTier || window?.planName?.startsWith('basic-'))
                    && (
                        <div className="mt2">
                            <Tippy content="Upgrade to share public links to your page">
                                <a
                                    href={getUpgradePlanUrl()}
                                    className="btn-tertiary btn-teal upgrade-button"
                                    title=""
                                >
                                    Upgrade to enable link sharing
                                </a>
                            </Tippy>
                        </div>
                    )}
                { !window.teamOnFreeTier && !window?.planName?.startsWith('basic-') && window.publicSharingEnabled && !authorizationLink && window.adminAllowsPageAuthorizations
                    && (
                        <>
                            <p className="yellow italic">
                            Shareable links are visible to anyone on the internet who has the link and may be indexed by
                            search engines.
                            </p>

                            <span onMouseDown={this.generateShareLink} className="btn btn-primary">Get shareable public link</span>
                        </>
                    )}
                { authorizationLink
                    && (
                        <div className="relative">
                            <input
                                readOnly
                                className="block col-12 mb2 field shareable-link"
                                type="text"
                                value={authorizationLink}
                            />
                            <span className="input-group-button">
                                <Tippy content="Copy to clipboard">
                                    <button className="clipboard-btn" title="copy to clipboard">
                                        <img className="clippy" src="/img/icons/clipboard-icon.svg" width="13" alt="Copy to clipboard" />
                                    </button>
                                </Tippy>
                            </span>
                            <span onMouseDown={this.onClickDestroy} className="btn btn-delete">Disable public link sharing</span>
                        </div>
                    )}
                <div className="mt3 right-align">
                    <span className="react-modal-close btn-secondary mr1" onMouseDown={this.close}>Close</span>
                </div>
            </div>
        );
    }
}

export default LinkMenu;
